/**
 * Media asset provider links
 */

export const MEDIA_ASSET_PROVIDER_BRIGHTCOVE_STUDIO_VIDEOS = '/products/videocloud/media/videos'
